/* eslint-disable */
import {
  BottomTabBar,
  createBottomTabNavigator,
} from '@react-navigation/bottom-tabs';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {Text, View, ActivityIndicator, StyleSheet} from 'react-native';
import Login from './screens/loginFlow/Login';
import {
  SafeAreaProvider,
  initialWindowMetrics,
  useSafeAreaInsets,
} from 'react-native-safe-area-context';
import {
  NavigationContainer,
  getFocusedRouteNameFromRoute,
} from '@react-navigation/native';
import LoginEmail from './screens/loginFlow/LoginEmail';
import CreateAccount from './screens/loginFlow/CreateAccount';
import ForgotPassword from './screens/loginFlow/ForgotPassword';
import VerifyOtp from './screens/loginFlow/VerifyOtp';
import UpdatePassword from './screens/loginFlow/UpdatePassword';
// Old Map & Route screens, replaced by mapFlow/MapSearch and MapPumpSearch.
// import Search from './screens/searchFlow/Search';
import ProfileList from './screens/profileFlow/ProfileList';
import Rewards from './screens/rewardsFlow/Rewards';
import AsyncStorage from '@react-native-async-storage/async-storage';
import {useEffect, useState} from 'react';
import Toast from 'react-native-toast-message';
import {useDispatch, useSelector} from 'react-redux';
import {alreadyLoggedIn, logoutUser} from './slice/loginSlice';
import {getProfile} from './slice/profileSlice';
import {setInactiveUserHandler} from './services/api-client';
import {colors, fonts, spacing, typography} from './config/theme';
import Scans from './screens/profileFlow/Scans';
import UploadReceipt from './screens/searchFlow/UploadReceipt';
import SearchScreen from './screens/searchFlow/SearchScreen';
// import PumpSearch from './screens/searchFlow/PumpSearch';
import MapSearch from './screens/mapFlow/MapSearch';
import MapPumpSearch from './screens/mapFlow/MapPumpSearch';
import MapIcon from './assets/icons/tab-map.svg';
import ScanIcon from './assets/icons/tab-scan.svg';
import GiftIcon from './assets/icons/tab-gift.svg';
import UserIcon from './assets/icons/tab-user.svg';
import Profile from './screens/profileFlow/Profile';
import Feedback from './screens/profileFlow/Feedback';
import MyFeedback from './screens/profileFlow/MyFeedback';
import FeedbackDetail from './screens/profileFlow/FeedbackDetail';
import DevSettings from './screens/profileFlow/DevSettings';
import AfterSignUp from './screens/loginFlow/AfterSignUp';
import { answerQuestions } from './slice/answerSlice';
import { useTranslation } from 'react-i18next';
import { Favourites } from './screens/profileFlow/favourites';
import OnboardingNavigator from './screens/onboardingFlow/OnboardingNavigator';
import {useDesktopLayout} from './utility/useDesktopLayout';
import DesktopAuthLayout from './components/desktop/DesktopAuthLayout';
import DesktopSidebar from './components/desktop/DesktopSidebar';
import {DesktopSidePanelHost} from './components/desktop/DesktopSidePanel';
import {
  FULL_WINDOW,
  useTabStackOptions,
} from './components/desktop/useTabStackOptions';

// Dev shortcut: true = open the new onboarding flow directly, skipping login
// (handy for design work). Keep it false: the real flow is login -> signup -> onboarding.
const TEST_NEW_ONBOARDING = false;

const Stack = createNativeStackNavigator();
const Tab = createBottomTabNavigator();

function LoginNavigator() {
  const {isAuthenticated} = useSelector(state=> state.login);
  // Logged in but not finished yet -> the new onboarding (route 'AfterSignUp').
  const initialRouteName = isAuthenticated ? 'AfterSignUp' : 'Login';
  return (
    <DesktopAuthLayout>
    <Stack.Navigator initialRouteName={initialRouteName} screenOptions={{headerShown: false}}>
      
      <Stack.Screen name="Login" component={Login} />
      <Stack.Screen name="LoginEmail" component={LoginEmail} />
      <Stack.Screen name="CreateAccount" component={CreateAccount} />
      <Stack.Screen name="ForgotPassword" component={ForgotPassword} />
      <Stack.Screen name="VerifyOtp" component={VerifyOtp} />
      <Stack.Screen name="UpdatePassword" component={UpdatePassword} />
      {/* New 5-screen onboarding. Whatever navigates to 'AfterSignUp' after
          signup now lands here. The old AfterSignUp.js file is left untouched
          (swap the component back to AfterSignUp to restore it). */}
      <Stack.Screen
        name="AfterSignUp"
        component={OnboardingNavigator}
        options={{gestureEnabled: false}}
      />
      {/* The old Question screens are removed. This alias only exists so any
          leftover navigation.navigate('Question') still lands on the onboarding.
          Delete it once nothing navigates to 'Question' any more. */}
      <Stack.Screen
        name="Question"
        component={OnboardingNavigator}
        options={{gestureEnabled: false}}
      />
    </Stack.Navigator>
    </DesktopAuthLayout>
  );
}

// Old Map & Route flow, kept commented out for reference.
// function SearchNavigator() {
//   const screenOptions = useTabStackOptions();
//   return (
//     <Stack.Navigator screenOptions={screenOptions}>
//       <Stack.Screen name="Search" component={Search} />
//       <Stack.Screen name="UploadReceipt" component={UploadReceipt} />
//       <Stack.Screen name="SearchScreen" component={SearchScreen} />
//       <Stack.Screen
//         name="PumpSearch"
//         component={PumpSearch}
//         options={FULL_WINDOW}
//       />
//     </Stack.Navigator>
//   );
// }

// Map & Route flow (first tab). The location picker and receipt upload are
// shared with the rest of the app.
function MapNavigator() {
  const screenOptions = useTabStackOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="MapSearch" component={MapSearch} />
      <Stack.Screen
        name="MapPumpSearch"
        component={MapPumpSearch}
        options={FULL_WINDOW}
      />
      <Stack.Screen name="SearchScreen" component={SearchScreen} />
      <Stack.Screen name="UploadReceipt" component={UploadReceipt} />
    </Stack.Navigator>
  );
}

function ProfileNavigator() {
  const screenOptions = useTabStackOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="ProfileList" component={ProfileList} />
      <Stack.Screen name="Profile" component={Profile} />
      <Stack.Screen name="Favourites" component={Favourites} />
      <Stack.Screen name="Feedback" component={Feedback} />
      <Stack.Screen name="MyFeedback" component={MyFeedback} />
      <Stack.Screen name="FeedbackDetail" component={FeedbackDetail} />
      <Stack.Screen name="DevSettings" component={DevSettings} />
    </Stack.Navigator>
  );
}

function ScansNavigator() {
  const screenOptions = useTabStackOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="Scans" component={Scans} />
    </Stack.Navigator>
  );
}

function RewardsNavigator() {
  const screenOptions = useTabStackOptions();
  return (
    <Stack.Navigator screenOptions={screenOptions}>
      <Stack.Screen name="Rewards" component={Rewards} />
    </Stack.Navigator>
  );
}

// Tab order puts the route planner first: it's the reason people open the app.
const TABS = {
  SearchTab: {Icon: MapIcon, label: 'root.BottomTab.Search'},
  // MapTab: {Icon: MapIcon, label: 'root.BottomTab.Map'},
  ScansTab: {Icon: ScanIcon, label: 'root.BottomTab.Scans'},
  RewardsTab: {Icon: GiftIcon, label: 'root.BottomTab.Rewards'},
  ProfileTab: {Icon: UserIcon, label: 'root.BottomTab.Profile'},
};

// Stack screens that hide the bottom tab bar (phones and native only).
const MAP_ROUTES = ['MapPumpSearch'];

function BottomTabNavigator() {
  const {t} = useTranslation();
  const insets = useSafeAreaInsets();
  const isDesktop = useDesktopLayout();
  return (
    <DesktopSidePanelHost>
    <Tab.Navigator
      initialRouteName="SearchTab"
      tabBar={props =>
        isDesktop ? (
          <DesktopSidebar {...props} tabs={TABS} />
        ) : (
          <BottomTabBar {...props} />
        )
      }
      screenOptions={({route}) => {
        const {Icon, label} = TABS[route.name];
        return {
          tabBarIcon: ({focused}) => (
            <View style={tabStyles.item}>
              <View style={[tabStyles.badge, focused && tabStyles.badgeActive]}>
                <Icon
                  width={22}
                  height={22}
                  color={focused ? colors.primary : colors.textSubtle}
                />
              </View>
              <Text
                numberOfLines={1}
                style={[tabStyles.label, focused && tabStyles.labelActive]}>
                {t(label)}
              </Text>
            </View>
          ),
          tabBarAccessibilityLabel: t(label),
          tabBarIconStyle: tabStyles.iconSlot,
          // The map screen is full screen: no bottom tab bar there.
          tabBarStyle: !isDesktop &&
            MAP_ROUTES.includes(getFocusedRouteNameFromRoute(route)) ? {display: 'none'} : {
            height: 72 + insets.bottom,
            paddingTop: spacing.sm,
            paddingBottom: insets.bottom,
            paddingHorizontal: spacing.sm,
            backgroundColor: colors.surface,
            borderTopWidth: 1,
            borderTopColor: colors.border,
            elevation: 0,
          },
          tabBarShowLabel: false,
          tabBarPosition: isDesktop ? 'left' : 'bottom',
          headerShown: false,
        };
      }}>
      <Tab.Screen name="SearchTab" component={MapNavigator} />
      {/* <Tab.Screen name="MapTab" component={MapNavigator} /> */}
      <Tab.Screen name="ScansTab" component={ScansNavigator} />
      <Tab.Screen name="RewardsTab" component={RewardsNavigator} />
      <Tab.Screen name="ProfileTab" component={ProfileNavigator} />
    </Tab.Navigator>
    </DesktopSidePanelHost>
  );
}

const tabStyles = StyleSheet.create({
  iconSlot: {
    width: '100%',
    height: '100%',
  },
  item: {
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
  },
  // Mint disc marks the active tab; inactive tabs get the same box so
  // labels don't shift when switching.
  badge: {
    width: 40,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeActive: {
    backgroundColor: colors.mintLine,
  },
  label: {
    ...typography.labelSm,
    letterSpacing: 0,
    color: colors.textSubtle,
  },
  labelActive: {
    fontFamily: fonts.bold,
    color: colors.primary,
  },
});

const Navigation = () => {
  const dispatch = useDispatch();
  // NOTE: don't read login `isLoading` here. Showing the full-screen spinner
  // while a login request runs would unmount the whole navigator, and a failed
  // login would then restart at the first screen instead of showing the error.
  const {isAuthenticated} = useSelector(state => state.login);
  const {has_answered,answerLoading} = useSelector(state => state.answer);
  const [isInitializing, setIsInitializing] = useState(true);

  // get-profile says isActive = 0 (account switched off): log the user out.
  useEffect(() => {
    let busy = false;
    setInactiveUserHandler(() => {
      if (busy) {
        return;
      }
      busy = true;
      dispatch(logoutUser());
      Toast.show({
        type: 'error',
        text1: 'Your account is not active. Please contact support.',
      });
      setTimeout(() => {
        busy = false;
      }, 3000);
    });
    return () => setInactiveUserHandler(null);
  }, [dispatch]);

  // Check the account once when the app opens / the user logs in, so a
  // deactivated user is logged out even before opening Profile.
  useEffect(() => {
    if (isAuthenticated) {
      dispatch(getProfile());
    }
  }, [isAuthenticated, dispatch]);

  useEffect(() => {
    const checkAuth = async () => {
      // dispatch(logoutUser());
      dispatch(alreadyLoggedIn());

      if (isAuthenticated) {
        dispatch(answerQuestions());
      }

      setIsInitializing(false);
    };

    checkAuth();
  }, [isAuthenticated, dispatch]);

  if (isInitializing || answerLoading) {
    return (
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: colors.background,
        }}>
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    );
  }

  // SafeAreaProvider renders nothing until the native view reports insets, and
  // with the UIScene window set up in AppDelegate.swift that report can fail
  // to arrive on iOS, leaving a white screen. Starting from the window's
  // metrics lets it render straight away.
  return (
    <SafeAreaProvider initialMetrics={initialWindowMetrics}>
      <NavigationContainer>
        <Stack.Navigator screenOptions={{headerShown: false}}>
          {TEST_NEW_ONBOARDING ? (
            <Stack.Screen name="OnboardingTest" component={OnboardingNavigator} />
          ) : isAuthenticated && has_answered ? (
            <Stack.Screen name="Main" component={BottomTabNavigator} />
          ) : (
            <Stack.Screen name="LoginSignup" component={LoginNavigator} />
          )}
        </Stack.Navigator>
      </NavigationContainer>
    </SafeAreaProvider>
  );
};
export default Navigation;